import { Button } from "../../../Common/Button"

interface IProps {
    onDownload(): void;
}

export const InscribeUI: React.FC<IProps> = ({ onDownload }) => {

    return (
        <>
            <div className="w-4/5 flex flex-col">
                <p className="interactions-text text-center text-lg mb-6">
                    How To Inscribe Your Game Code:
                </p>
                <div className="mb-6">
                    <p className="interactions-text text-sm text-center text-cs mb-5">
                        <span className="text-bold">1.</span> Download Your Code File
                    </p>
                    <p className="interactions-text text-sm text-center text-cs font-bold mb-5">
                        <span className="text-bold">2.</span> Head Over To  <a href="https://bellscribe.com" target="_blank" className="no-underline text-grey">
                            <span className="interactions-text text-sm text-center text-cs font-bold mb-[8px]">
                                Bellscribe
                            </span>
                        </a> And Follow The Instructions To Inscribe Your Code File
                    </p>
                    <p className="interactions-text text-sm text-center text-cs font-xs">
                        <span className="font-bold">3.</span> Once You've Inscribed Your Game Code and Have It's Tx Id, Head Back To WowBoi. Insert Your Game And Play!
                    </p>
                </div>
                <div className="flex flex-col items-center">
                    <Button
                        text="Download Code"
                        alertMessage="Downloading!"
                        onClick={onDownload}
                        className="w-[200px] mb-4 bg-white text-lg px-3 py-2"
                    />
                    <p className="interactions-text text-center mb-4 mt-6 w-11/12 text-xs font-bold" >
                        Make Sure To <a href="https://www.uglifyjs.net/" target="_blank" className="text-grey"> Minify Your Code </a> before downloading.<br /> Although This Is Optional, It Is Highly Recommended! Minifying will allow you to store larger and cheaper files on a blockchain.
                    </p>
                </div>
            </div>
        </>
    )
}